<template>
    <div class="flex justify-center max-w-full">
        <div v-if="loading" class="calendar loading" :style="'max-width: 50%'">
            <i class="fa fa-spinner fa-spin fa-fw fa-4x"></i>
        </div>
        <div class="max-w-full" :class="(loading ? 'loading-bg' : '') + ' calendar'">
            <div class="calendar-navigation" :class="darkHeader ? 'text-gray-800' : 'text-white'">
                <div class="d-flex"><i class="fa fa-arrow-left" @click="previousMonth()"></i></div>
                <div class="navigation-month font-compact d-flex align-items-center">
                    <div v-if="monthSelectVisible">
                        <input type="month" v-model="month" ref="month">
                    </div>
                    <div v-else>{{ this.selectedMonth.format('MMMM YYYY') }}</div>
                    <i class="fa fa-calendar ml-2" @click="toggleMonthSelect"></i>
                </div>
                <div class="d-flex"><i class="fa fa-arrow-right" @click="nextMonth()"></i></div>
            </div>
            <div class="calendar-calendar">
                <div class="calendar-headers">
                    <div v-if="showWeekNumber" class="calendar-header text-base sm:text-sm md:text-base d-flex flex-1 justify-content-start"><span class="hidden sm:inline"></span></div>
                    <div class="calendar-header text-base sm:text-sm md:text-base d-flex flex-1 "><span class="hidden sm:inline">{{ transEdit('monday') }}</span><span class="sm:hidden">{{ transEdit('monday').substring(0,2).toLocaleLowerCase()}}</span></div>
                    <div class="calendar-header text-base sm:text-sm md:text-base d-flex flex-1 "><span class="hidden sm:inline">{{ transEdit('tuesday') }}</span><span class="sm:hidden">{{ transEdit('tuesday').substring(0,2).toLocaleLowerCase()}}</span></div>
                    <div class="calendar-header text-base sm:text-sm md:text-base d-flex flex-1 "><span class="hidden sm:inline">{{ transEdit('wednesday') }}</span><span class="sm:hidden">{{ transEdit('wednesday').substring(0,2).toLocaleLowerCase()}}</span></div>
                    <div class="calendar-header text-base sm:text-sm md:text-base d-flex flex-1 "><span class="hidden sm:inline">{{ transEdit('thursday') }}</span><span class="sm:hidden">{{ transEdit('thursday').substring(0,2).toLocaleLowerCase()}}</span></div>
                    <div class="calendar-header text-base sm:text-sm md:text-base d-flex flex-1 "><span class="hidden sm:inline">{{ transEdit('friday') }}</span><span class="sm:hidden">{{ transEdit('friday').substring(0,2).toLocaleLowerCase()}}</span></div>
                    <div class="calendar-header text-base sm:text-sm md:text-base d-flex flex-1 "><span class="hidden sm:inline">{{ transEdit('saturday') }}</span><span class="sm:hidden">{{ transEdit('saturday').substring(0,2).toLocaleLowerCase()}}</span></div>
                    <div class="calendar-header text-base sm:text-sm md:text-base d-flex flex-1 "><span class="hidden sm:inline">{{ transEdit('sunday') }}</span><span class="sm:hidden">{{ transEdit('sunday').substring(0,2).toLocaleLowerCase()}}</span></div>
                </div>
                <div class="calendar-week" v-for="weekNumber in 6" :key="weekNumber">
                  <div v-if="showWeekNumber && getDate(weekNumber, 1)" class="calendar-day flex-1 justify-content-start" style="color: #0099ff;">
                    v.{{getWeekNumber(getDate(weekNumber, 1))}}
                  </div>
                    <div class="calendar-day-border flex-1" v-for="dayNumber in 7" :key="dayNumber">
                        <calendar-day :selected-date="selectedDate"
                                      :canSelectOutsideMonth="canSelectOutsideMonth"
                                      :date="getDate(weekNumber, dayNumber)"
                                      :canSelectEmpty="canSelectEmpty"
                                      :today="today"
                                      :disablePastDays="disablePastDays"
                                      @dateClicked="dateClicked"
                                      :noColorCoding="noColorCoding"
                        ></calendar-day>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        name: "calendar",
        props: {
            initialDate: {
                default: null
            },
            isCustomer: {
              default: true
            },
            isTherapist: {
              default: false
            },
            dateKey: {
                default: 'date'
            },
            ajaxUrl: {
                default: null
            },
            canSelectEmpty: {
                default: false
            },
            maxWidth: {
                default: '100%'
            },
            canSelectOutsideMonth: {
                default: true,
            },
            disablePastDays: {
                default: false,
            },
            noColorCoding: {
                default: false,
            },
            darkHeader: {
                default: false,
            },
            openInitial: {
                default: false,
            },
            showWeekNumber: {
                default: false,
            }
        },
        watch:{
            ajaxUrl(){
                this.ajaxEvents();
            }
        },
        data(){
            return {
                startDate: null,
                endDate: null,
                today: null,
                selectedMonth: null,
                selectedDate: null,
                dates: [],
                data: [],
                absenceDates: [],
                loading: false,
                monthSelectVisible: false,
                cancelSource: null,
            }
        },

        methods:{
            toggleMonthSelect()
            {
                this.monthSelectVisible = !this.monthSelectVisible;
                if(this.monthSelectVisible) {
                    this.$nextTick(() => this.$refs.month.focus());
                }
            },

            dateClicked(date){
                this.selectedDate = moment(date.date);
                this.$emit('daySelected', date)
            },
            previousMonth(){
                this.selectedMonth = this.selectedMonth.subtract(1, 'months');
                this.startDate =  this.selectedMonth.clone().startOf('month').startOf('isoWeek');
                this.endDate =this.selectedMonth.clone().endOf('month').endOf('isoWeek');
                this.ajaxEvents();
                this.$emit('monthChanged', this.selectedMonth);
            },
            nextMonth(){
                this.selectedMonth = this.selectedMonth.add(1, 'months');
                this.startDate =  this.selectedMonth.clone().startOf('month').startOf('isoWeek');
                this.endDate =this.selectedMonth.clone().endOf('month').endOf('isoWeek');
                this.ajaxEvents();
                this.$emit('monthChanged', this.selectedMonth);
            },
            fillDates(){
                let dates = [];
                let current = this.startDate.clone();
                while(true){
                    let date = current.clone();
                    dates.push({
                        date: date,
                        otherMonth: current.get('month') !== this.selectedMonth.get('month'),
                        events: this.getEventsForDate(date),
                        symbol: this.getSymbolForDate(date),
                        absence: this.getAbsenceForDate(date),
                    });

                    if(this.openInitial && this.initialDate.isSame(date, 'day')){
                        this.$emit('daySelected', dates[dates.length -1] );
                    }

                    current = current.add(1, 'days');
                    if(current.isSameOrAfter(this.endDate)){
                        break;
                    }
                }

                this.dates = dates;
                this.$forceUpdate();

            },
            getEventsForDate(date){
                if(this.data && this.data.events){
                    return _.filter(this.data.events, (event) => {
                        return date.isSame(event[this.dateKey], 'day');
                    });
                }
                return [];
            },
            getSymbolForDate(date){
                if(this.data && this.data.date_symbols) {
                    return this.data.date_symbols[date.format('YYYY-MM-DD')];
                }

                return null;
            },
            getAbsenceForDate(date){
                if(this.data && this.data.absenceDates) {
                    return this.data.absenceDates.includes(date.format('YYYY-MM-DD'));
                }

                return null;
            },
            getDate(week, day){
                return this.dates[(7 * (week -1)) + (day -1)];
            },

            ajaxEvents(){
                if(!this.ajaxUrl){
                    this.fillDates();
                    return null;
                }

                if(this.cancelSource) {
                    this.cancelSource.cancel();
                }

                this.loading = true;

                let cancelToken = axios.CancelToken;
                this.cancelSource = cancelToken.source();

                let start = this.startDate.format('YYYY-MM-DD');
                let end = this.endDate.format('YYYY-MM-DD');
                axios.get(this.ajaxUrl,{
                    cancelToken: this.cancelSource.token,
                    params: {
                        start_date: start,
                        end_date: end
                    }
                }).then((res) => {
                   this.data = res.data;
                   this.fillDates();
                   this.loading = false;
                   this.cancelSource = null;
                }).catch((res) => {
                    this.data = [];
                    this.loading = false;
                    this.cancelSource = null;
                });
            },
            getWeekNumber(dateObj) {
                const date = new Date(dateObj.date.toString());
                date.setHours(0, 0, 0, 0);
                date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
                const week1 = new Date(date.getFullYear(), 0, 4);

                return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
                    - 3 + (week1.getDay() + 6) % 7) / 7);
            },
        },
        computed: {
            month: {
                get() {
                    return this.selectedMonth.format('YYYY-MM');
                },
                set(value) {
                    this.selectedMonth = moment(value);
                    this.startDate =  this.selectedMonth.clone().startOf('month').startOf('isoWeek');
                    this.endDate =this.selectedMonth.clone().endOf('month').endOf('isoWeek');

                    this.toggleMonthSelect();
                    this.ajaxEvents();
                    this.$emit('monthChanged', this.selectedMonth);
                }
            }
        },

        created(){
            this.today = moment();
            this.selectedMonth = moment().startOf('isoMonth');
            this.startDate = moment().startOf('month').startOf('isoWeek');
            this.endDate = moment().endOf('month').endOf('isoWeek');
            if(this.openInitial && this.initialDate) {
                this.dateClicked(this.initialDate)
            }
        },
        mounted () {
            if (this.initialDate) {
                this.selectedDate = this.initialDate;
                this.selectedYear = this.initialDate.clone().startOf('isoYear');
                this.selectedMonth = this.initialDate.clone().startOf('isoMonth');
                this.startDate = this.initialDate.clone().startOf('month').startOf('isoWeek');
                this.endDate = this.initialDate.clone().endOf('month').endOf('isoWeek');
            } else {
                this.selectedDate = moment();
            }

            this.ajaxEvents();
        }
    }
</script>
